(function () {

    function addButtons() {

        document.querySelectorAll(".jm-review-item").forEach(review => {

            if (review.querySelector(".te-review-feedback")) return;

            review.insertAdjacentHTML(
    "beforeend",
    `
    <div class="te-review-feedback">

        <button class="te-review-btn up" aria-label="Like">

            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 1.97-1.68l1.38-9A2 2 0 0 0 19.66 9H14z"/>
                <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
            </svg>

        </button>

        <button class="te-review-btn down" aria-label="Dislike">

            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-1.97 1.68l-1.38 9A2 2 0 0 0 4.34 15H10z"/>
                <path d="M17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3"/>
            </svg>

        </button>

    </div>
    `
);

            const feedback = review.querySelector(".te-review-feedback");
            const up = feedback.querySelector(".up");
            const down = feedback.querySelector(".down");

            up.onclick = () => {
                up.classList.toggle("active-up");
                down.classList.remove("active-down");
            };

            down.onclick = () => {
                down.classList.toggle("active-down");
                up.classList.remove("active-up");
            };

        });

    }

    const timer = setInterval(() => {

        if (document.querySelector(".jm-review-item")) {

            addButtons();

            clearInterval(timer);

        }

    }, 500);

})();

document.addEventListener("DOMContentLoaded", () => {

    const params = new URLSearchParams(window.location.search);

    if (!params.has("write-review")) return;

    const timer = setInterval(() => {

        const btn = document.querySelector('[data-testid="write-review-button"]');

        if (!btn) return;

        clearInterval(timer);
        btn.click();

    }, 200);

});